import { useEffect, useState } from "react";

export function useScrollProgress(
  containerRef: React.RefObject<HTMLElement | null>,
) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const article = containerRef.current;
      const featured = article?.querySelector(
        '[class*="article-carousel-wrapper-"]',
      );
      const keywords = article?.querySelector(
        '[data-testid="tag-wrapper"] > span:last-of-type',
      );

      if (!featured || !keywords) return;

      const start = featured.getBoundingClientRect().top + window.scrollY;
      const end = keywords.getBoundingClientRect().top + window.scrollY - 70;

      const value = ((window.scrollY - start) / (end - start)) * 100;
      setProgress(Math.min(100, Math.max(0, value)));
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [containerRef]);

  return progress;
}
